import { Col, Modal, Row } from "antd";
import React, { useEffect } from "react";
import BaseButton from "../../components/common/Button/BaseButton";
import InputSearchBox from "../../components/common/Input/InputSearchBox";
import "../../assets/style/pageStyle/store.scss";
import { useDispatch, useSelector } from "react-redux";
import { bannerSelector, pupSelector } from "../../services/selector/index.";
import Notify from "../../components/common/Notify";
import { setOpenPUDelete } from "../../services/slice/PopUpSlice";
import { useTranslation } from "react-i18next";
import { IconPlus, IconSave, IconSetting } from "../../assets/icon";
import TranslateText from "../../components/common/TranslateText";
import NoSearchResults from "../../components/common/NoSearchResults";
import { useState } from "react";
import TableAdManager from "../../components/common/Table/TableAdManager";
import {
  deleteBanner,
  resetState,
  resetStateBanner,
  saveAllConfig,
  setOpenModalAddBanner,
  setOpenModalGetLogBanner,
  setValueConfig,
} from "../../services/slice/BannerSlice";
import ModalEditBanner from "../../components/common/Modal/edit/ModalEditBanner";
import ModalGetLog from "../../components/common/Modal/getLog/ModalGetLog";
import ModalSetLimitBanner from "../../components/common/Modal/other/ModalSetLimitBanner";
import ModalPreviewProduct from "../../components/common/Modal/getDetail/ModalPreviewProduct";
import ModalAddBanner from "../../components/common/Modal/add/ModalAddBanner";
import ModalDelete from "../../components/common/Modal/delete/ModalDelete";

const AdManager = () => {
  const bannerState = useSelector(bannerSelector);
  const pupState = useSelector(pupSelector);
  const { dataDelete } = pupState;
  const [showPreview, setShowPreview] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  useEffect(() => {
    return () => dispatch(resetState());
  }, []);
  const handleDelete = () => {
    dispatch(deleteBanner(dataDelete.id));
    dispatch(setOpenPUDelete({ stateOpen: false, id: "", content: "" }));
  };
  const { numberBannerDefault, dataBanner, listChangeBanner } = bannerState;
  const [openCofigLimit, setOpenCofigLimit] = useState(false);
  const [number, setNumber] = useState();
  useEffect(() => {
    if (numberBannerDefault) {
      setNumber(numberBannerDefault);
    }
  }, [numberBannerDefault]);
  const handleSaveAllConFig = () => {
    const dataSave = [];
    for (let i = 0; i < dataBanner.length; i++) {
      for (let j = 0; j < listChangeBanner.length; j++) {
        let banner = dataBanner[i];
        let itemChange = listChangeBanner[j];
        if (
          banner.id === itemChange.id &&
          banner.status === 1 &&
          banner.index !== itemChange.index
        ) {
          dataSave.push({
            id: banner.id,
            status: 1,
            index: itemChange.index,
          });
        }
        if (
          banner.id === itemChange.id &&
          banner.status !== itemChange.status
        ) {
          dataSave.push(itemChange);
        }
      }
    }
    if (dataSave.length) {
      dispatch(
        saveAllConfig({
          config: [
            {
              name: "banner",
              number: numberBannerDefault,
            },
          ],
          list: [...dataSave],
        })
      );
    } else {
      Modal.error({
        className: "wrapperModalErrConfigBanner",
        centered: true,
        width: 590,
        title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,

        content: (
          <>
            <p style={{ fontSize: 20 }}>
              Hiện chưa có sự thay đổi nào so với trạng thái ban đầu.
            </p>
          </>
        ),
      });
    }
  };
  return (
    <div className="wrapperStoreManager">
      {bannerState.isOpenModalEditBanner ? (
        <ModalEditBanner title={"Chỉnh sửa banner"} />
      ) : null}
      {bannerState.isOpenModalGetLog && (
        <ModalGetLog
          open={bannerState.isOpenModalGetLog}
          setOpen={setOpenModalGetLogBanner}
          data={bannerState.dataLog}
        />
      )}
      {openCofigLimit ? (
        <ModalSetLimitBanner
          open={openCofigLimit}
          setOpen={setOpenCofigLimit}
          setNumber={setNumber}
          number={number}
        />
      ) : null}
      {showPreview ? (
        <ModalPreviewProduct open={showPreview} setOpen={setShowPreview} />
      ) : null}
      {bannerState.isOpenModalAddBanner ? (
        <ModalAddBanner title={"Thêm mới banner"} />
      ) : null}
      {/* {bannerState.isOpenModalEdit && <ModalEditProduct />} */}
      {dataDelete.isOpenPUDelete && (
        <ModalDelete
          handleDelete={handleDelete}
          width={600}
          title="Xóa banner"
          textDisable="Bạn có đồng ý xóa sản banner"
        />
      )}

      <Notify
        isNotify={bannerState.isNotify}
        reset={resetStateBanner}
        title={"Bkav Pro"}
        content={bannerState.msg}
        type={bannerState.typeNotify}
      />
      <Row className="headerPage">
        <h2 className="title" style={{ marginRight: "1.5rem" }}>
          <TranslateText text={"Quản lý banner"} />
        </h2>
        <span onClick={() => setOpenCofigLimit(true)}>
          <IconSetting />
        </span>
      </Row>

      <Row style={{ width: "100%" }}>
        <Col>
          <InputSearchBox
            setText={(value) => {
              dispatch(setValueConfig({ search: value }));
            }}
            width={435}
            placeholder={"Tìm kiếm theo tên banner"}
          />
        </Col>
        <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
          <BaseButton
            handleClick={() => dispatch(setOpenModalAddBanner(true))}
            width={120}
            typeBtn={"btnOrange mr-5"}
            icon={
              <IconPlus
                width={16}
                height={14}
                style={{ marginRight: "0.5rem" }}
              />
            }
            content={`Thêm mới`}
          />
          <BaseButton
            handleClick={handleSaveAllConFig}
            width={120}
            typeBtn={"btnOrange"}
            icon={
              <IconSave
                width={16}
                height={14}
                fill="white"
                style={{ marginRight: "0.5rem" }}
              />
            }
            content={`Lưu`}
          />
        </Col>
      </Row>
      <Row>
        {bannerState.config.search && !bannerState.dataBanner.length ? (
          <NoSearchResults />
        ) : (
          <TableAdManager number={number} />
        )}
      </Row>
    </div>
  );
};

export default AdManager;
